import { ChevronDown, ChevronUp } from "lucide-react";

// Sidebar footer for clinicians' short menu: expand to every tool their role can open, or back to the daily set.
export const NavToolsToggle = ({ showAll, hiddenCount, onToggle, collapsed = false, testId = "nav-show-all-tools" }) => {
  const Icon = showAll ? ChevronUp : ChevronDown;
  const label = showAll ? "Show fewer tools" : `Show all tools${hiddenCount ? ` (${hiddenCount} more)` : ""}`;
  return (
    <button
      type="button"
      onClick={onToggle}
      title={collapsed ? label : undefined}
      className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-xs font-semibold uppercase tracking-[0.08em] text-slate-500 hover:text-emerald-400 hover:bg-slate-800/40 transition-colors duration-200"
      data-testid={testId}
    >
      <Icon className="w-4 h-4" />
      {!collapsed && <span>{label}</span>}
    </button>
  );
};
